import APIClient from '@/shared/http/clients/api'

const resourceName = 'captacao-remunerada-diaria'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)

/**
 * @name CaptacaoRemuneradaDiariaRepository
 * @description Captação Remunerada Diária
 * @type { Respository }
 */
const CaptacaoRemuneradaDiariaRepository = {
  Search
}

export default CaptacaoRemuneradaDiariaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/captacaoremuneradadiaria.js